import React from 'react';
import PropTypes from 'prop-types';
import { Bar, CheckBox } from 'Components';
import './BarCheck.css';

const BarCheck = props => (
  <Bar className="bar-check">
    { props.isDisabled
        ? <span>-</span>
        : <CheckBox checked={props.checked} onClick={props.onClick} />
    }
    <div>{props.text}</div>
  </Bar>
);

BarCheck.propTypes = {
  checked: PropTypes.bool,
  text: PropTypes.node,
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default BarCheck;



// WEBPACK FOOTER //
// ./src/components/BarCheck/BarCheck.jsx